module.exports = {
      id: "bedroom-usage",
      viewBox: "0 0 19 16.7",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#bedroom-usage",
      toString: function () {
        return this.url;
      }
    }